import { ChangeDetectorRef, Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from '../../services/api.service';
import { SimpleTableComponent } from '../../generals/Components';

@Component({
  selector: 'app-cartstatisticsdetail',
  templateUrl: './cartstatisticsdetail.component.html',
  styleUrls: ['./cartstatisticsdetail.component.scss']
})
export class CartstatisticsdetailComponent extends SimpleTableComponent<any> {

  constructor(
    private apiServiceRef: ApiService,
    private changeDetectionRef: ChangeDetectorRef,
    private config: DynamicDialogConfig
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'statistics/cart/' + this.config.data.id;
  }
}
